import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ArrowRightLeftIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M19.4822 13.3582V7.6112C19.4822 7.12384 19.0565 6.72871 18.5312 6.72871H10.2067V3.88345C10.2067 3.10482 9.19396 2.70748 8.59213 3.25126L1.28738 9.85244C0.90376 10.1991 0.904651 10.771 1.28738 11.1169L8.59213 17.7182C9.19319 18.2613 10.2067 17.8654 10.2067 17.086V14.2407H18.5312C19.0565 14.2407 19.4822 13.8455 19.4822 13.3582Z"
        fill="currentColor"
      />
      <path
        d="M30.7126 19.8841L23.4079 13.2828C22.8068 12.7397 21.7933 13.1356 21.7933 13.915V16.7602H13.4688C12.9435 16.7602 12.5178 17.1554 12.5178 17.6427V23.3897C12.5178 23.8771 12.9435 24.2722 13.4688 24.2722H21.7933V27.1175C21.7933 27.8985 22.8096 28.2902 23.4079 27.7497L30.7126 21.1484C31.0962 20.8018 31.0954 20.23 30.7126 19.8841Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
